module.exports = __webpack_public_path__ + "c3b3c44e3542ff87471da551accf7ced.fbx";